export default "__VITE_ASSET__CNqGaV8L__"